module.exports = __webpack_public_path__ + "media/images/application/icons/icon-subscribe-rocket-c2b9bc60d197943d2ff9122dfb6775b9.svg";